




























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import SortIcon from '../icons/SortIcon.vue';
import { SortingOption } from '@/store/modules/searchInterfaces';
import InfoTooltip from '@/components/common/InfoTooltip.vue';
import { SearchModule } from '@/store/modules/search';

@Component({
  components: {
    SortIcon,
    InfoTooltip
  }
})
export default class SearchTableHeaderSorting extends Vue {
  @Prop(Object) sorting!: SortingOption;

  get state() {
    return SearchModule;
  }

  clickSortOption(property: SortingOption['property']) {
    let descending = false;

    if (this.sorting && property === this.sorting.property) {
      descending = !this.sorting.descending;
    }

    this.$emit('change', { property, descending });
  }
}
